module.exports = __webpack_public_path__ + "img/group3.eaaedf53.png";